import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ArrowDownGlyph = /*#__PURE__*/createElement("g", {
  id: "arrow_down"
}, /*#__PURE__*/createElement("path", {
  d: "M66,39.8c-1.2-1.1-3.1-1.1-4.2,0.1L45,57.5V19c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v38.5L22.3,39.9c-1.1-1.2-3-1.2-4.2-0.1 c-1.2,1.1-1.2,3-0.1,4.2l21.9,23c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.2 c0,0,0.1,0,0.1,0c0.4,0.2,0.8,0.2,1.2,0.2c0.4,0,0.8-0.1,1.2-0.2c0,0,0.1,0,0.1,0c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1 c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0l21.9-23C67.2,42.9,67.2,41,66,39.8z"
}));
const ArrowDown = createSvg({
  name: 'arrow_down',
  path: ArrowDownGlyph
});

export default ArrowDown;
export { ArrowDownGlyph };
